/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface LiveWidgetSegmentAPI
 * @example dashboard.getFeature('LiveWidgetSegment)
 */
define([], () => {
	class LiveWidgetSegmentAPI {

		/**
		 * @function LiveWidgetSegmentAPI#track
		 * @description Track a segment event for live widget actions
		 * @param {Object} event The information about the event that is being tracked
		 * @param {String} event.category The event that we track. Values accepted: fromRecommendation, Recommended, Other, colorPalette.
		 * @param {Object} event.visualization The visualization API for the vis that is being tracked
		 * @param {Object} event.info Additional details about the event
		 */
		track() {}

	}

	return LiveWidgetSegmentAPI;
});